import { useEffect, useState } from 'react';
import { storageService } from '@/utils/storage';
import type { SuscripcionEstado } from '@/modelos/Auth';

export function useSuscripcion(): SuscripcionEstado | null {
  const [suscripcion, setSuscripcion] = useState(() => storageService.getSuscripcion());

  useEffect(() => {
    const sync = () => setSuscripcion(storageService.getSuscripcion());
    window.addEventListener('senciyo:workspace-updated', sync);
    return () => window.removeEventListener('senciyo:workspace-updated', sync);
  }, []);

  return suscripcion;
}
